import type { StaffingPlan } from '../operations/planModel';

// 모의 화면의 초안만 저장합니다. 실제 API 응답은 이 저장소에 넣지 않습니다.
const storageKey = 'heyday-fixture-staffing-plans-v1';
const initialPlans: StaffingPlan[] = [{
  id: 'fixture-staffing-plan', title: '10월 조직 개편안', effectiveDate: '2026-10-01', reason: '플랫폼 개발 조직을 신설합니다.',
  organizationChanges: [{ key: 'new-platform', operation: 'CREATE', name: 'Platform Enablement Team', parent: { id: 'engineering' } }],
  workerChanges: [], version: 1, status: 'DRAFT', createdAt: '2026-09-20T00:00:00Z', updatedAt: '2026-09-20T00:00:00Z',
}];

let plans = initialPlans;

export function listFixtureStaffingPlans(): StaffingPlan[] {
  if (typeof window !== 'undefined') {
    try {
      const stored: unknown = JSON.parse(window.localStorage.getItem(storageKey) ?? 'null');
      if (Array.isArray(stored) && stored.every((item) => item && typeof item.id === 'string' && item.id.startsWith('fixture-') && Array.isArray(item.organizationChanges) && Array.isArray(item.workerChanges))) plans = stored;
    } catch { /* 사용할 수 없는 모의 저장소는 메모리 상태로 계속 진행합니다. */ }
  }
  return plans;
}
export function getFixtureStaffingPlan(id: string) { return listFixtureStaffingPlans().find((plan) => plan.id === id); }
export function saveFixtureStaffingPlan(plan: StaffingPlan) {
  if (!plan.id.startsWith('fixture-')) throw new Error('실제 발령안은 모의 저장소에 저장할 수 없습니다.');
  plans = [plan, ...listFixtureStaffingPlans().filter(item => item.id !== plan.id)];
  if (typeof window !== 'undefined') window.localStorage.setItem(storageKey, JSON.stringify(plans));
}
